import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const HeaderController = () => {
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const productref = useRef(null);
  const companyRef = useRef(null);
  const mobileExpandRef = useRef(null);
  const bottomHeader = useRef(null);

  const [showProducts, setShowProducts] = useState(false);
  const [showProductsmob, setShowProductsmob] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [indexValue, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const [showSolutions, setShowSolutions] = useState(false);
  const [showCompany, setShowCompany] = useState(false);
  const [showCompanymob, setShowCompanymob] = useState(false);

  const toggleHamburger = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };


  const navigate = useNavigate();

  const NavigateTo = (route) => {
    setShowProducts(false);
    setShowSolutions(false);
    setShowCompany(false);
    navigate(route);
  };

  const handleProductClick = () => {
    setShowSolutions(false);
    setShowCompany(false);
    setShowProducts((prev) => !prev);
    setShowProductsmob((prev) => !prev);
  };

  const handleSolutionsClick = () => {
    setShowProducts(false);
    setShowCompany(false);
    setShowSolutions((prev) => !prev);
  };

  const handleCompanyClick = () => {
    setShowProducts(false);
    setShowSolutions(false);
    setShowCompany((prev) => !prev);
  };

  const handleNavigate = (link) => {
    setShowProductsmob(false);
    setShowProducts(false);
    setShowSolutions(false);
    setShowCompany(false);
    setMenuOpen(false);
    NavigateTo(link);
  };

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
    setShowProducts(false);
    setShowProductsmob(false);
    setShowSolutions(false);
    setShowCompany(false);
  };

  useEffect(() => {
    if (showProducts || isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showProducts, isOpen]);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const hamburgerClicked = e.target.closest(
        ".mobile-page-bottom-header-icon-container"
      );

      if (hamburgerClicked) return;

      const clickedInsideDropdown = dropdownRef.current?.contains(e.target);
      const clickedInsideMenu = menuRef.current?.contains(e.target);
      const productClick = productref.current?.contains(e.target);
      const companyClick = companyRef.current?.contains(e.target);
      
      // Also check if clicked inside the popup containers (they are siblings of the span)
      const clickedInsidePopup = e.target.closest('.solutions-popup');

      const isOutsideAll =
        !clickedInsideDropdown &&
        !clickedInsideMenu &&
        !productClick &&
        !companyClick &&
        !clickedInsidePopup;

      const mobileExpandRefClick = mobileExpandRef.current?.contains(e.target);
      const bottomHeaderClick = bottomHeader.current?.contains(e.target);
      const isMobileOutsideClick = !mobileExpandRefClick && !bottomHeaderClick;

      if (isOutsideAll) {
        setShowProducts(false);
        setShowSolutions(false);
        setShowCompany(false);
        setMenuOpen(false);
      }

      if (isMobileOutsideClick) {
        setIsOpen(false);
        setShowProductsmob(false);
        setShowCompanymob(false);
      }
    };

    document.addEventListener("click", handleOutsideClick, true);
    document.addEventListener("touchstart", handleOutsideClick, true);

    return () => {
      document.removeEventListener("click", handleOutsideClick, true);
      document.removeEventListener("touchstart", handleOutsideClick, true);
    };
  }, []);

  return {
    NavigateTo,
    handleProductClick,
    handleSolutionsClick,
    handleCompanyClick,
    handleNavigate,
    showProducts,
    setShowProducts,
    setShowProductsmob,
    menuOpen,
    setMenuOpen,
    indexValue,
    setIndex,
    toggleMenu,
    dropdownRef,
    menuRef,
    hamburgerRef,
    productref,
    toggleHamburger,
    isOpen,
    setIsOpen,
    showProductsmob,
    mobileExpandRef,
    showSolutions,
    setShowSolutions,
    showCompany,
    setShowCompany,
    showCompanymob,
    setShowCompanymob,
    bottomHeader,
    companyRef,
  };
};
